import React,{ useState,useEffect } from 'react';
import ReactDOM from 'react-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
// import IconButton from '@material-ui/core/IconButton';
// import DeleteIcon from '@material-ui/icons/Delete';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import CallMadeIcon from '@material-ui/icons/CallMade';
import Hidden from '@material-ui/core/Hidden';
// import Grid from '@material-ui/core/Grid';

import Slider from '@material-ui/core/Slider';
// import States from "./model_gl/config";

const useStyles = makeStyles((theme) => ({
   root: {
      width: 170,
   },
   newBtns: {
      borderRadius: "0.1em",
   },


   margin: {
      // margin: theme.spacing(2),
      // borderRadius: "0.1em",
      // textTransform: 'none',
      // fontSize: '0.7em'
   },
   extendedIcon: {
      marginRight: theme.spacing(1),
   },
}));


export default function FooterControlMob(props) {

   var prevCounter = 0;
   var nextClicked = false;
   var prevClicked = false;

   const classes = useStyles();
   const [value,setValue] = React.useState(30);
   const [prevDeltaScene,setPrevDeltaScene] = React.useState(0);
   const [zoombarValue,setZoombarValue] = React.useState(0);

   const handleChange = (event,newValue) => {
      setValue(newValue);
   };

   const handleZoomChange = (e,newValue) => {



      if (e) { //console.log(e.target.value);
         window.scene._nav.NavChangeDolly(undefined,e.target.value / 100);

      } else {


         window.scene._nav.NavChangeDolly(undefined,newValue / 100);

         document.getElementById("sliderRange").value = newValue;


         //document.getElementById('sliderRange').setAttribute('aria-label', (newValue * 100)+ '%');
      }
      window.hotspot = '';


   };

   const zoombar = {
      height: '47px',
      position: 'relative',
      float: 'left',
      marginLeft: '4px',
      width: '175px'
   }

   const topbtns = {
      position: 'relative',
      // bottom: '149px',
      // marginLeft: '13.5%',
      // marginBottom: '21px',
      border: '1px solid CCCCCC',
      float: 'left',
   }
   const mobthreeButtonsIpad = {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.005em',
      backgroundColor: '#FFFFFF',
      height: '48px',
      width: 'calc(100% / 3)',
      margin: '5px',
      border: '2px solid #CCCCCC'
   }
   const mobthreeButtons = {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.005em',
      backgroundColor: '#FFFFFF',
      height: '48px',
      width: 'calc(100% / 3)',
      margin: '5px',
      border: '2px solid #CCCCCC'
   }
   const topLeft = {
      transform: 'rotate(270deg)',
      fontSize: '1.5em'
   }
   const topRight = {
      fontSize: '1.5em'
   }
   const prev = {
      marginRight: '12px',
      fontSize: '1.8em'
   }
   const next = {
      marginLeft: '12px',
      fontSize: '1.8em'
   }
   const topBtnstyle = {
      height: '47px',
      width: '62px',
      marginLeft: '8.5px',
      marginRight: '8.5px',
      backgroundColor: '#FFFFFF',
      border: '2px solid #CCCCCC'
   }
   const clearBoth = {
      clear: 'both'
   }
   //only for mob
   const [camData,setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;
   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            console.log(myJson.positions);
            setCamData(myJson.positions);
         });
   }
   useEffect(() => {
      getData();
      animationSwitch = window.Animation;
      window.position = 'reset';
      return () => {
         return false
      }
   },[]);

   //For Animation Switch 
   console.log('animationSwitch anim',animationSwitch)

   if (animationSwitch == 'on') { animTime = 1000 }
   else { animTime = 1 }
   console.log('animTime',animTime)


   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname,onComplete,onSample) => {
      // below code is updated in it.  
      // updated code ends here
      var opt = undefined,gp = camData[gotoposname];
      console.log(gp);
      //    console.log(gp)
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      var animationSwitch = window.Animation;
      if (animationSwitch == 'off') { gp.time = 1 }
      else {
         gp.time = animTime;
      }
      console.log('animationSwitch',animationSwitch);
      console.log('gp.time',gp.time);
      window.scene.gotoPosInTime(gp.pos[0],gp.pos[1],gp.pos[2],gp.pos[3],gp.pos[4],gp.time,onComplete,slowInOut,opt);
      // console.log(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4], gp.time, onComplete, onSample, opt);
   }
   //end

   const slowInOut = (x) => {
      var a = 3.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x,a);
      var px2 = Math.pow(x2,a);

      return px / (px + px2);
   }

   // const resetBacklitCloseImg = () =>{
   //     setOpenCloseOnOff(false);
   //     setOpenClose("./img/Lid_open.svg");
   //     setBackliteOnOff(false);
   //     setBacklite("./img/Backlite_Off.svg");
   //     // window.scene.materialReplace('LED_Backlit_ON_env', 'LED_Backlit_OFF_env');
   //     window.scene.clearRefine();

   // }
   const resetTimeline1 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_01_A')) window.scene.getAnim("Screen_grp_timeline_01_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_01_A')) window.scene.getAnim("Hinge_grp_timeline_01_A").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_01_A')) window.scene.getAnim("Main_grp_timeline_01_A").stop();

      if (revers90Degree) {
         // window.scene.animPlayInTime("Screen_90_degree", 0, 0);
         // window.scene.animPlayInTime("Screen_90_to_close180", 0, 0);
         // window.scene.animPlayInTime("Screen_90_to_close360", 0, 0);
      }
      window.scene.animPlayInTime("Screen_grp_timeline_01_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_01_A",0,0);
      window.scene.animPlayInTime("Main_grp_timeline_01_A",0,0);
      window.scene.clearRefine();
   }
   const resetTimeline2 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_02_A')) window.scene.getAnim("Screen_grp_timeline_02_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_02_A')) window.scene.getAnim("Hinge_grp_timeline_02_A").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_02_A')) window.scene.getAnim("Main_grp_timeline_02_A").stop();
      if (revers90Degree) {
         // window.scene.animPlayInTime('Screen_90_degree', 0, 0);
         // window.scene.animPlayInTime('Screen_90_degree_180', 0, 0);

      }
      window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,0);
      window.scene.animPlayInTime("Main_grp_timeline_02_A",0,0);
      window.scene.clearRefine();
   }
   const resetTimeline3 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_03_A')) window.scene.getAnim("Screen_grp_timeline_03_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_03_A')) window.scene.getAnim("Hinge_grp_timeline_03_A").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_03_A')) window.scene.getAnim("Main_grp_timeline_03_A").stop();
      if (revers90Degree) {
         // window.scene.animPlayInTime('Screen_90_degree', 0, 0);
         // window.scene.animPlayInTime('Screen_90_degree_180', 0, 0);

      }
      window.scene.animPlayInTime("Screen_grp_timeline_03_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_03_A",0,0);
      window.scene.animPlayInTime("Main_grp_timeline_03_A",0,0);
      window.scene.clearRefine();
   }
   const resetTimeline4 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_04_A')) window.scene.getAnim("Main_grp_timeline_04_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_04_A')) window.scene.getAnim("Hinge_grp_timeline_04_A").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_04_A')) window.scene.getAnim("Screen_grp_timeline_04_A").stop();
      if (revers90Degree) {
         // window.scene.animPlayInTime('Screen_90_degree', 0, 0);
         // window.scene.animPlayInTime('Screen_90_degree_180', 0, 0);

      }
      window.scene.animPlayInTime("Main_grp_timeline_04_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0,0);
      window.scene.animPlayInTime("Screen_grp_timeline_04_A",0,0);
      window.scene.clearRefine();
   }
   const posClicked1 = () => {
      window.scene.animPlayInTime("Screen_grp_timeline_01",0,animTime);

   }

   const onResetMob = () => {

      if (window.laptop == 'laptop180') {

         window.scene.groupApplyState("screenfill_180");
      } else if (window.laptop == 'laptop180') {

         window.scene.groupApplyState("screenfill_360");
      }
      // posClicked1();
      setCounter(0);
      //setExpandedPanel(false);
      resetTimeline1();
      resetTimeline2();
      resetTimeline3();
      resetTimeline4();
      setPort1Click(false);
      setPort2Click(false);
      setPort3Click(false);
      setPort4Click(false);
      setPort5Click(true);

      window.closeMode = '';
      window.scene.groupApplyState("Backlit_OFF");
      window.hotspot = '';

      var isClose = window.closeMode;
      if (port1Click == true) {
         console.log("tent to reset");
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.5,0);

         window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",0,animTime);

      }
      else if (port2Click == true) {
         console.log("theater to reset");
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",1.7,0);

         window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",0.00,animTime);

      }
      else if (port3Click == true) {
         console.log("tablet to reset");
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",8,animTime);

      }
      else if (port4Click == true) {
         console.log("close to reset");
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         //   window.scene.animPlayInTime("Screen_grp_timeline_01", 0, 1500);
         //   window.scene.animPlayInTime("Screen_grp_timeline_01_A", 6.7, 0);
         //   window.scene.animPlayInTime("Hinge_grp_timeline_01_A", 6.7, 0);
         //   window.scene.animPlayInTime("Main_grp_timeline_01_A", 6.7, 0);
         // window.scene.animPlayInTime("Screen_grp_timeline_01_A", 8.31, 1500);
         //   window.scene.animPlayInTime("Hinge_grp_timeline_01_A", 8.31, 1500);
         //   window.scene.animPlayInTime("Main_grp_timeline_01_A", 8.31, 1500);

         if (!isClose) {
            console.log("if");
            window.scene.animPlayInTime("Screen_90_degree",1.66,0);
            window.scene.animPlayInTime("Screen_90_degree",0,1500);
            // window.scene.animPlayInTime("Screen_grp_timeline_01", 1.66, 0);
            window.scene.animPlayInTime("Screen_grp_timeline_01",0,1500);


            window.scene.clearRefine();

         } else {
            console.log("else");

            window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.41,animTime);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.41,animTime);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",8.41,animTime);
            window.scene.clearRefine();

         }

      }
      else {
         console.log("no");
         // resetTimeline1();
         // resetTimeline2();
         // resetTimeline3();
         // resetTimeline4();
         setPort1Click(false);
         setPort2Click(false);
         setPort3Click(false);
         setPort4Click(false);
         setPort5Click(true);

         if (port4Click == true) {
            GotoPosInTimeNamedValue('Render_Cam_F01_FL',function () {
               if (window.color == 'Carbon_Fibre') {
                  window.scene.groupApplyState("Carbon_Fibre_180A");
                  window.scene.groupApplyState("Screen_Fill_180_ON");
               } else if (window.color == 'Silver') {
                  window.scene.groupApplyState("Silver");
                  window.scene.groupApplyState("Screen_Fill_180_Silver_ON");
               }
               if (!isClose) {
                  window.scene.animPlayInTime("Screen_90_degree",0,1500);
                  window.scene.animPlayInTime("Screen_grp_timeline_01",0,1500);

                  window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
                  window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
                  window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
                  window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.41,animTime);
                  window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.41,animTime);
                  window.scene.animPlayInTime("Main_grp_timeline_01_A",8.41,animTime);
                  //  } else{


                  //  }
               }
            });
         }
         GotoPosInTimeNamedValue('Render_Cam_F01_FL',function () {
            if (window.color == 'Carbon_Fibre') {
               window.scene.groupApplyState("Carbon_Fibre_180A");
               window.scene.groupApplyState("Screen_Fill_180_ON");
            } else if (window.color == 'Silver') {
               window.scene.groupApplyState("Silver");
               window.scene.groupApplyState("Screen_Fill_180_Silver_ON");
            }
            window.scene.animPlayInTime('Screen_90_degree',0,animTime);
            window.scene.animPlayInTime("Screen_grp_timeline_01",0,animTime);
            // window.scene.animPlayInTime("screen_90_degree_animation", 0, animTime);
            window.scene.clearRefine();
         });
      }
   }
   //front to top 
   const onFrontClick = () => {

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');
      document.getElementById('frontBtn').classList.add('active');
      window.position = 'reset';
      window.scene.groupApplyState("screen_180");

      resetTimeline1();
      resetTimeline2();
      resetTimeline3();
      resetTimeline4();

      if (nextClick) {
         console.log("next")
         setNextClick(true)
         setPrevClick(false)
         if (window.laptop == 'laptop180') {
            setCounter(1);
         } else if (window.laptop == 'laptop360') {
            setCounter(4);
         }

      }

      if (prevClick) {
         console.log("previuos")

         setNextClick(false)
         setPrevClick(true)
         if (window.laptop == 'laptop180') {
            setCounter(6);
         } else if (window.laptop == 'laptop360') {
            setCounter(2);
         }
      }

      window.scene.clearRefine();
      setPort1Click(false);
      setPort2Click(false);
      setPort3Click(false);
      setPort4Click(false);
      window.scene.groupApplyState("Backlit_OFF");
      var isClose = window.closeMode;

      if (port1Click == true) {
         window.scene.gotoPosInTime(0,0,-2,1.1237486091039337,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",0,animTime);
      }
      if (port2Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",1.7,0);

         window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",0.00,animTime);
      }
      if (port3Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",8,animTime);
      }
      if (port4Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         if (!isClose) {
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.41,animTime);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.41,animTime);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",8.41,animTime);
         } else {
            window.scene.animPlayInTime("Screen_90_degree",1.66,0);
            window.scene.animPlayInTime("Screen_grp_timeline_01",1.66,0);

         }
      }


      GotoPosInTimeNamedValue('Render_Cam_F196_JD',function () {
         window.scene.animPlayInTime('Screen_90_degree',0.62,animTime,function () {
            window.hotspot = 'front';

         });
         window.scene.animPlayInTime('Screen_grp_timeline_01',0.34,animTime,function () {
            window.hotspot = 'front';

         });
         window.scene.clearRefine();
      })

   }

   const onRightClick = () => {

      if (nextClick) {
         console.log("next")
         setNextClick(true)
         setPrevClick(false)
         //  setCounter(5)
         if (window.laptop == 'laptop180') {
            setCounter(3);
         } else if (window.laptop == 'laptop360') {
            setCounter(6);
         }
      }
      if (prevClick) {
         console.log("previuos")

         setNextClick(false)
         setPrevClick(true)
         //  setCounter(3)
         if (window.laptop == 'laptop180') {
            setCounter(1);
         } else if (window.laptop == 'laptop360') {
            setCounter(4);
         }
      }
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');
      document.getElementById('rightBtn').classList.add('active');
      window.position = 'reset';
      window.scene.groupApplyState("screen_180");
      var isClose = window.closeMode;

      resetTimeline1();
      resetTimeline2();
      resetTimeline3();
      resetTimeline4();
      setPort1Click(false);
      setPort2Click(false);
      setPort3Click(false);
      setPort4Click(false);

      window.scene.groupApplyState("Backlit_OFF");
      if (port1Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",0,animTime);
      }
      if (port2Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",0.00,animTime);
      }
      if (port3Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",8,animTime);
      }
      if (port4Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         if (!isClose) {

            window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.41,animTime);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.41,animTime);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",8.41,animTime);
         } else {
            window.scene.animPlayInTime("Screen_90_degree",1.66,0);
            window.scene.animPlayInTime('Screen_grp_timeline_01',1.66,0)

         }
      }

      GotoPosInTimeNamedValue('Render_Cam_F194_R',function () {
         window.scene.animPlayInTime('Screen_grp_timeline_01',0.45,animTime,function () {
            window.hotspot = 'right';

         });
         window.scene.animPlayInTime("Screen_90_degree",0.83,animTime,function () {
            window.hotspot = 'right';

         });
         window.scene.clearRefine();
      });
   }

   const onLeftClick = () => {

      if (nextClick) {
         console.log("next")
         setNextClick(true)
         setPrevClick(false)
         if (window.laptop == 'laptop180') {
            setCounter(4);
         } else if (window.laptop == 'laptop360') {
            setCounter(7);
         }
      }


      if (prevClick) {
         console.log("previuos")

         setNextClick(false)
         setPrevClick(true)
         //  setCounter(4)
         if (window.laptop == 'laptop180') {
            setCounter(3);
         } else if (window.laptop == 'laptop360') {
            setCounter(5);
         }
      }
      var isClose = window.closeMode;

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');
      document.getElementById('leftBtn').classList.add('active');
      window.position = 'reset';
      window.scene.groupApplyState("screen_180");

      resetTimeline1();
      resetTimeline2();
      resetTimeline3();
      resetTimeline4();
      setPort1Click(false);
      setPort2Click(false);
      setPort3Click(false);
      setPort4Click(false);

      window.scene.groupApplyState("Backlit_OFF");
      if (port1Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",0,animTime);
      }
      if (port2Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",0.00,animTime);
      }
      if (port3Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",8,animTime);
      }
      if (port4Click == true) {
         console.log("4")
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         if (!isClose) {
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.41,animTime);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.41,animTime);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",8.41,animTime);
         } else {
            window.scene.animPlayInTime("Screen_90_degree",1.66,0);
            window.scene.animPlayInTime("Screen_grp_timeline_01",1.66,0);

         }
      }


      GotoPosInTimeNamedValue('Render_Cam_F194_L',function () {
         window.scene.animPlayInTime("Screen_grp_timeline_01",0.45,animTime,function () {
            window.hotspot = 'left';

         });

         window.scene.animPlayInTime("Screen_90_degree",0.83,animTime,function () {
            window.hotspot = 'left';

         });
         window.scene.clearRefine();
      });
   }
   const onTopClick = () => {

      if (nextClick) {
         console.log("next")
         setNextClick(true)
         setPrevClick(false)
         if (window.laptop == 'laptop180') {
            setCounter(2);
         } else if (window.laptop == 'laptop360') {
            setCounter(5);
         }
      }

      if (prevClick) {
         console.log("previuos")

         setNextClick(false)
         setPrevClick(true)
         //  setCounter(2)
         if (window.laptop == 'laptop180') {
            setCounter(0);
         } else if (window.laptop == 'laptop360') {
            setCounter(3);
         }
      }
      var isClose = window.closeMode;

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');
      document.getElementById('topBtn').classList.add('active');
      window.position = 'reset';
      window.scene.groupApplyState("screen_180");

      resetTimeline1();
      resetTimeline2();
      resetTimeline3();
      resetTimeline4();

      setPort1Click(false);
      setPort2Click(false);
      setPort3Click(false);
      setPort4Click(false);

      window.scene.groupApplyState("Backlit_OFF");
      if (port1Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",0,animTime);
      }
      if (port2Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",0.00,animTime);
      }
      if (port3Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",8,animTime);
      }
      if (port4Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         if (!isClose) {
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.41,animTime);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.41,animTime);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",8.41,animTime);
         } else {
            window.scene.animPlayInTime("Screen_90_degree",1.66,0);
            window.scene.animPlayInTime("Screen_grp_timeline_01",1.66,0);

         }
      }

      GotoPosInTimeNamedValue('Render_Cam_F198_Top',function () {
         window.scene.animPlayInTime("Screen_90_degree",0.50,animTime,function () {
            window.hotspot = 'top';

         });
         window.scene.animPlayInTime('Screen_grp_timeline_01',0.26,animTime,function () {
            window.hotspot = 'top';

         });
      });

      window.scene.clearRefine();
   }


   const openCloseClick = () => {

      if (nextClick) {
         console.log("next")
         setNextClick(true)
         setPrevClick(false)
         if (window.laptop == 'laptop180') {
            setCounter(5);
         } else if (window.laptop == 'laptop360') {
            setCounter(8);

         }
      }
      if (prevClick) {
         console.log("previuos")

         setNextClick(false)
         setPrevClick(true)
         if (window.laptop == 'laptop180') {
            setCounter(5);
         } else if (window.laptop == 'laptop360') {
            setCounter(6);

         }
      }
      var fromPos = window.hotspot
      window.hotspot = '';
      window.closeMode = 'on';

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');
      document.getElementById('openCloseBtn').classList.add('active');
      window.scene.groupApplyState("screen_180");

      setBackliteOnOff(false);
      window.scene.groupApplyState("Backlit_OFF");

      if (port1Click == true) {
         console.log('abcd');
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",0,animTime);
      }
      if (port2Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",0.00,animTime);
      }
      if (port3Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",8,animTime);
      }

      console.log(backliteOnOff);
      //window.scene.materialReplace('LED_Backlit_ON_env', 'LED_Backlit_OFF_env');
      setBacklite("./img/Backlite_Off.svg");

      window.scene.animPlayInTime("Screen_90_degree_180",0,0);
      window.scene.animPlayInTime("Screen_90_degree",0,0);
      window.scene.clearRefine();
      if (openCloseOnOff) {

         setPort1Click(false);
         setPort2Click(false);
         setPort3Click(false);
         setPort4Click(false);
         setOpenCloseOnOff(false);
         console.log("open");
         setOpenClose("./img/Lid_open.svg");


         window.scene.groupApplyState("dynamic_reset");
         //window.scene.materialReplace('LED_Backlit_ON_env', 'LED_Backlit_OFF_env');
         GotoPosInTimeNamedValue('Render_Cam_F01_FL',function () {



         });
         window.scene.animPlayInTime("Screen_90_degree",0,1);
         window.scene.animPlayInTime("Screen_grp_timeline_01",0,1500);
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.41,1500);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.41,1500);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",8.41,1500);
         window.scene.clearRefine();
      } else {
         setPort1Click(false);
         setPort2Click(false);
         setPort3Click(false);
         setPort4Click(true);
         setOpenCloseOnOff(true);
         console.log("close");
         setBackliteOnOff(false);
         setOpenClose("./img/Lid_close.svg");

         window.scene.groupApplyState("dynamic_reset");
         GotoPosInTimeNamedValue('Close_Cam_F158_Close',function () {


         });
         if (fromPos == 'right' || fromPos == 'left' || fromPos == 'front' || fromPos == 'top' || fromPos == 'backlit') {
            // alert('right')
            window.scene.animPlayInTime("Screen_90_degree",1.66,1500);

            window.scene.animPlayInTime("Screen_grp_timeline_01",1.66,1500);

            window.scene.clearRefine();
         } else {
            console.log("else close")
            window.scene.animPlayInTime("Screen_grp_timeline_01",1.66,1500);

            window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.41,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.41,0);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",8.41,0);

            window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,1500);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,1500);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,1500);

            window.scene.clearRefine();
         }

      }

   }

   const backliteClick = () => {

      if (nextClick) {
         console.log("next")
         setNextClick(true)
         setPrevClick(false)
         if (window.laptop == 'laptop180') {
            setCounter(0);
         } else if (window.laptop == 'laptop360') {
            setCounter(0);
         }
      }
      if (prevClick) {
         console.log("previuos")

         setNextClick(false)
         setPrevClick(true)
         if (window.laptop == 'laptop180') {
            setCounter(6);
         } else if (window.laptop == 'laptop360') {
            setCounter(7);
         }
      }
      window.hotspot = '';

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');
      document.getElementById('backlitBtn').classList.add('active');
      window.position = 'reset';
      window.scene.groupApplyState("screen_180");

      resetTimeline1();
      resetTimeline2();
      resetTimeline3();
      resetTimeline4();
      var isClose = window.closeMode;
      if (port1Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",0,animTime);
      }
      if (port2Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",0.00,animTime);
      }
      if (port3Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",8,animTime);
      }
      if (port4Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         if (!isClose) {
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.31,animTime);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.31,animTime);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",8.31,animTime);
         } else {
            window.scene.animPlayInTime("Screen_90_degree",1.66,0);

         }
      }

      if (!openCloseOnOff) {

      }


      GotoPosInTimeNamedValue('Render_Cam_F198_Top',function () {

         window.hotspot = 'backlit';
         window.scene.animPlayInTime("Screen_grp_timeline_01",0.26,animTime);
         window.scene.animPlayInTime("Screen_90_degree",0.50,animTime);
         window.scene.clearRefine();
      })

      if (backliteOnOff) {
         setPort1Click(false);
         setPort2Click(false);
         setPort3Click(false);
         setPort4Click(false);
         console.log("off");
         setBackliteOnOff(false);

         window.scene.groupApplyState("Backlit_OFF");
         window.scene.clearRefine();
         setBacklite("./img/Backlite_Off.svg");
      } else {
         setPort1Click(false);
         setPort2Click(false);
         setPort3Click(false);
         setPort4Click(false);
         setBackliteOnOff(true);
         console.log("on");
         setBacklite("./img/Backlite_On.svg");
         window.scene.groupApplyState("Backlit_ON");
         window.scene.clearRefine();



      }
   }


   //menufeature

   const color1Click = () => {
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');

      window.position = 'reset';
      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");
      window.scene.groupApplyState("screen_180");

      setPort4Click(false);
      if (port4Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.31,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.31,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",8.31,animTime);
      }

      window.color = 'silver';
      window.scene.groupApplyState("Silver");
      window.scene.groupApplyState("screenfill_180");
      window.scene.clearRefine();

      // }


   }

   const color2Click = () => {
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');
      document.getElementById('blackBtn').classList.add('active');
      window.position = 'reset';

      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");
      window.scene.groupApplyState("screen_180");

      setPort2Click(false);
      setPort1Click(false);
      setPort3Click(false);
      setPort4Click(false);
      if (port4Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.31,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.31,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",8.31,animTime);

      }

      window.color = 'Carbon_Black';
      window.scene.groupApplyState("Carbon_Black");
      window.scene.groupApplyState("screenfill_180");
      window.scene.clearRefine();
      // }  
   }

   //end

   //tent theater tablet
   const TentModeClick = () => {
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');
      document.getElementById('tentBtn').classList.add('active');
      window.scene.groupApplyState("screen_360");

      if (nextClick) {
         console.log("next");
         window.laptop = 'laptop360';
         setNextClick(true)
         setPrevClick(false)
         setCounter(1)
      }
      if (prevClick) {
         console.log("previuos")
         window.laptop = 'laptop360';
         setNextClick(false)
         setPrevClick(true)
         setCounter(8)
      }
      setPort1Click(true);
      setPort2Click(false);
      setPort3Click(false);
      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");
      resetTimeline1();
      resetTimeline2();
      resetTimeline3();
      resetTimeline4();
      window.scene.groupApplyState("Backlit_OFF");
      window.scene.animPlayInTime("Screen_90_degree",0,0);
      window.scene.instanceSet("Tent_Mode_","visible",true);
      if (port2Click == true) {
         console.log('2to1');
         GotoPosInTimeNamedValue('Tent_Cam_F53_Tent');
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",3.8,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",3.8,0);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",3.8,0);

         window.scene.animPlayInTime("Screen_grp_timeline_01_A",2.6,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",2.6,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",2.6,animTime);
         window.scene.instanceSet("Tent_Mode_","visible",true);
         window.scene.clearRefine();
      }
      else if (port3Click == true) {
         console.log('3to1');
         GotoPosInTimeNamedValue('Tent_Cam_F53_Tent');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5,0);

         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.6,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.6,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.6,animTime);
         window.scene.clearRefine();
      } else {
         console.log('1to1');
         if (port1Click == true) {
            console.log("1");
            GotoPosInTimeNamedValue('Tent_Cam_F53_Tent');
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",0.04166,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",0.04166,0);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",0.04166,0);

            window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.6,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.6,0);
            window.scene.animPlayInTime("Main_grp_timeline_02_A",2.6,0);
            window.scene.clearRefine();
         } else {
            console.log("2");
            GotoPosInTimeNamedValue('Tent_Cam_F53_Tent');
            window.scene.animPlayInTime("Screen_grp_timeline_01_A",0.04166,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_01_A",0.04166,0);
            window.scene.animPlayInTime("Main_grp_timeline_01_A",0.04166,0);

            window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.6,animTime);
            window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.6,animTime);
            window.scene.animPlayInTime("Main_grp_timeline_02_A",2.6,animTime);
            window.scene.clearRefine();
         }
      }

   }

   const TheaterModeClick = () => {
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');
      document.getElementById('theaterBtn').classList.add('active');
      window.scene.groupApplyState("screen_180");

      if (nextClick) {
         console.log("next")
         window.laptop = 'laptop360';
         setNextClick(true)
         setPrevClick(false)
         setCounter(2)
      }
      if (prevClick) {
         console.log("previuos")
         window.laptop = 'laptop360';
         setNextClick(false)
         setPrevClick(true)
         setCounter(0)
      }
      setPort2Click(true);
      setPort1Click(false);
      setPort3Click(false);
      resetTimeline1();
      resetTimeline2();
      resetTimeline3();
      resetTimeline4();
      window.scene.groupApplyState("Backlit_OFF");
      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");
      window.scene.animPlayInTime("Screen_90_degree",0,0);
      if (port1Click == true) {
         console.log('1to2');
         GotoPosInTimeNamedValue('Stand_Cam_F95_Stand');
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",2.5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",2.5,0);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",2.5,0);

         window.scene.animPlayInTime("Screen_grp_timeline_01_A",3.8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",3.8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",3.8,animTime);
      }
      else if (port3Click == true) {
         console.log('3to2');
         GotoPosInTimeNamedValue('Stand_Cam_F95_Stand');
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",5,0);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",5,0);

         window.scene.animPlayInTime("Screen_grp_timeline_01_A",3.8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",3.8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",3.8,animTime);
      } else {
         console.log('2to2');


         if (port2Click == true) {
            console.log("1")
            GotoPosInTimeNamedValue('Stand_Cam_F95_Stand');
            window.scene.animPlayInTime("Main_grp_timeline_04_A",0.4,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.4,0);
            window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.4,0);

            window.scene.animPlayInTime("Main_grp_timeline_04_A",1.8,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.8,0);
            window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.8,0);
            window.scene.clearRefine();
         } else {
            console.log("2");
            GotoPosInTimeNamedValue('Stand_Cam_F95_Stand');
            window.scene.animPlayInTime("Main_grp_timeline_04_A",0.4,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.4,0);
            window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.4,0);

            window.scene.animPlayInTime("Main_grp_timeline_04_A",1.8,animTime);
            window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.8,animTime);
            window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.8,animTime);
            window.scene.clearRefine();
         }
      }


   }
   const TabletModeClick = () => {
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');
      document.getElementById('tabletBtn').classList.add('active');
      window.scene.groupApplyState("screen_180");

      if (nextClick) {
         console.log("next")
         window.laptop = 'laptop360';
         setNextClick(true)
         setPrevClick(false)
         setCounter(3)
      }
      if (prevClick) {
         console.log("previuos")
         window.laptop = 'laptop360';
         setNextClick(false)
         setPrevClick(true)
         setCounter(1)
      }
      setPort3Click(true);
      setPort1Click(false);
      setPort2Click(false);
      resetTimeline1();
      resetTimeline2();
      resetTimeline3();
      resetTimeline4();
      window.scene.groupApplyState("Backlit_OFF");
      //window.scene.materialReplace('LED_Backlit_ON_env', 'LED_Backlit_OFF_env');
      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");
      // resetTimeline2();
      // resetTimeline4();
      window.scene.animPlayInTime("Screen_90_degree",0,0);
      if (port1Click == true) {
         console.log('1to3');
         //window.scene.gotoPosInTime(5.867081672070415, -0.03458257862338644, -2.391488170611039, -6.5, 0, 1000);
         GotoPosInTimeNamedValue('Tablet_Cam_F118_Tablet');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.9,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.9,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.9,0);

         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5,animTime);
         window.scene.clearRefine();
      }
      else if (port2Click == true) {
         console.log('2to3');
         // window.scene.gotoPosInTime(5.867081672070415, -0.03458257862338644, -2.391488170611039, -6.5, 0, 1000);
         GotoPosInTimeNamedValue('Tablet_Cam_F118_Tablet');
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",4.2,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",4.2,0);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",4.2,0);

         window.scene.animPlayInTime("Screen_grp_timeline_01_A",5.1,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",5.1,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",5.1,animTime);
         window.scene.clearRefine();
      }
      else {
         console.log('3to3');
         //window.scene.gotoPosInTime(5.867081672070415, -0.03458257862338644, -2.391488170611039, -6.5, 0, 1000);


         if (port3Click == true) {
            console.log("1")
            GotoPosInTimeNamedValue('Tablet_Cam_F118_Tablet');
            window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,0);
            window.scene.animPlayInTime("Main_grp_timeline_02_A",8,0);

            window.scene.animPlayInTime("Screen_grp_timeline_02_A",5,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5,0);
            window.scene.animPlayInTime("Main_grp_timeline_02_A",5,0);
            window.scene.clearRefine();
         } else {
            console.log("2")
            GotoPosInTimeNamedValue('Tablet_Cam_F118_Tablet');
            window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,0);
            window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,0);
            window.scene.animPlayInTime("Main_grp_timeline_02_A",8,0);

            window.scene.animPlayInTime("Screen_grp_timeline_02_A",5,animTime);
            window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5,animTime);
            window.scene.animPlayInTime("Main_grp_timeline_02_A",5,animTime);
            window.scene.clearRefine();
         }


      }

   }

   //end

   const laptopClick = (event) => {
      setlaptop180(true);
      setlaptop360(false);
      console.log(laptop180);
      setCounter(0);
      setValue(event.target.value);
      // setDisplayed(true);
      // setExpandedPanel(false);
      // setHidden(false);
      setPort1Click(false);
      setPort2Click(false);
      setPort3Click(false);
      setPort4Click(false);
      posClicked1();
      resetTimeline1();
      resetTimeline2();
      resetTimeline3();
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("dynamic_reset");
      window.scene.groupApplyState("screenfill_180");


      window.position = 'reset';
      window.laptop = 'laptop180';
      window.closeMode = '';
      window.scene.animPlayInTime("Screen_90_degree",0,0);

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      alreadySelected.classList.remove('active');

      var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      alreadySelecte.classList.remove('select');

      if (port1Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",0,animTime);
      }
      if (port2Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",0.00,animTime);
      }
      if (port3Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",8,animTime);
      }
      if (port4Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.31,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.31,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",8.31,animTime);
      }
      window.scene.animPlayInTime('Screen_90_degree',0,animTime);
      window.scene.animPlayInTime("screen_90_degree_animation",0,animTime);
      window.scene.animPlayInTime('Screen_90_degree_180',0,animTime);
      GotoPosInTimeNamedValue('Render_Cam_F01_FL',function () {
         //window.scene.instanceSet("Latitude_7410_Chromebook_Enterprise_360", "visible", false);
         //window.scene.instanceSet("Latitude_7410_Chromebook_Enterprise_180", "visible", true);

         window.scene.groupApplyState("Silver_180");
         window.scene.groupApplyState("Screen_Fill_180_Silver_ON");
      });

      window.scene.clearRefine();
   }

   // const [value, setValue] = useState('2 in 1');

   const select2in1Click = (event) => {
      setlaptop360(true);
      setlaptop180(false);
      console.log(laptop360);
      setCounter(0);
      setValue(event.target.value);
      // setDisplayed(false);
      // setHidden(true);
      // setExpandedPanel(false);
      setPort1Click(false);
      setPort2Click(false);
      setPort3Click(false);
      setPort4Click(false);
      window.hotspot = '';
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("GP_open");
      window.position = 'reset';
      window.scene.groupApplyState("screenfill_360");
      // window.scene.groupApplyState("dynamic_open");
      window.scene.groupApplyState("dynamic_reset");

      window.laptop = 'laptop360';
      window.hotspot = '';
      window.closeMode = '';
      window.scene.animPlayInTime("Screen_90_degree",0,0);

      if (port1Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",2.5,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",0,animTime);
      }
      if (port2Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",1.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0.00,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_04_A",0.00,animTime);
      }
      if (port3Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",5.4,0);
         window.scene.animPlayInTime("Screen_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_02_A",8,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_02_A",8,animTime);
      }
      if (port4Click == true) {
         GotoPosInTimeNamedValue('Render_Cam_F01_FL');
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",6.7,0);
         window.scene.animPlayInTime("Screen_grp_timeline_01_A",8.31,animTime);
         window.scene.animPlayInTime("Hinge_grp_timeline_01_A",8.31,animTime);
         window.scene.animPlayInTime("Main_grp_timeline_01_A",8.31,animTime);
      }
      // setLaptop360FrontImg("./img/front360.png");
      // setLaptop360TopImg("./img/top360.png");
      // setLaptop360LefttImg("./img/left.png");
      // setLaptop360RightImg("./img/right.png");

      // resetBacklitCloseImg();
      window.scene.animPlayInTime('Screen_90_degree',0,animTime);
      window.scene.animPlayInTime("screen_90_degree_animation",0,animTime);
      window.scene.animPlayInTime('Screen_90_degree_180',0,animTime);
      GotoPosInTimeNamedValue('Render_Cam_F01_FL',function () {
         window.scene.groupApplyState("Silver");
         //window.scene.instanceSet("Latitude_7410_Chromebook_Enterprise_360", "visible", true);
         //window.scene.instanceSet("Latitude_7410_Chromebook_Enterprise_180", "visible", false);
         //window.scene.instanceSet("GP_Laptop_360", "visible", true);
      });

      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("Open_mode", "visible", false);
      //window.scene.instanceSet("normal_screen", "visible", true);
      //window.scene.instanceSet("tent_mode_screen", "visible", false);
      window.scene.clearRefine();

   }
   const [openCloseOnOff,setOpenCloseOnOff] = useState(false);
   const [backlit,setBacklite] = useState("./img/Backlite_Off.svg");
   const [opneClose,setOpenClose] = useState("./img/Lid_open.svg");
   const [backliteOnOff,setBackliteOnOff] = useState(false);
   const [laptop360,setlaptop360] = useState(true);
   const [laptop180,setlaptop180] = useState(false);
   const [counter,setCounter] = useState(0);
   const [port1Click,setPort1Click] = useState(false);
   const [port2Click,setPort2Click] = useState(false);
   const [port3Click,setPort3Click] = useState(false);
   const [port4Click,setPort4Click] = useState(false);
   const [port5Click,setPort5Click] = useState(true);
   const [nextClick,setNextClick] = useState(false);
   const [prevClick,setPrevClick] = useState(false);

   const onPreviousMob = () => {
      // if(counter > 0)

      if (nextClicked) {
         // alert('iffff');
         // return;
         prevCounter = counter - 2;
      } else {
         // alert('else');
         prevCounter = counter;
      }
      setNextClick(false);
      setPrevClick(true);
      console.log("****************** Inside prev prevCounter",prevCounter);
      console.log("****************** Inside prev",counter);
      if (window.laptop == 'laptop180') {
         // setlaptop180(true);

         switch (prevCounter) {

            case 0:
               // setExpandedPanel("panel1");
               onFrontClick();
               setCounter(5);
               setNextClick(false);
               setPrevClick(true);
               break;

            case 1:
               onTopClick();

               console.log('top',counter);
               setCounter(0);
               setNextClick(false);
               setPrevClick(true);
               break;

            case 2:

               onRightClick();
               console.log('left',counter);
               setCounter(1);
               setNextClick(false);
               setPrevClick(true);
               break;

            case 3:
               // setExpandedPanel("panel1");
               onLeftClick();
               console.log('right',counter);
               setCounter(2);
               setNextClick(false);
               setPrevClick(true);
               break;

            case 4:
               // setExpandedPanel("panel3");

               openCloseClick();

               console.log('openclose',counter);
               setCounter(3);
               setNextClick(false);
               setPrevClick(true);
               break;
            case 5:
               // setExpandedPanel("panel3");

               backliteClick();
               console.log('backliteOnOff',counter);
               setCounter(4);
               setNextClick(false);
               setPrevClick(true);
               break;

         }

      } else {
         // setlaptop180(false);

         switch (prevCounter) {
            case 0:
               TentModeClick();

               console.log('tent',counter);
               setCounter(8);
               setNextClick(false);
               setPrevClick(true);
               break;


            case 1:
               TheaterModeClick();
               console.log('next cha theater',counter);
               setCounter(0);
               setNextClick(false);
               setPrevClick(true);
               break;

            case 2:
               // setExpandedPanel("panel2");
               TabletModeClick();
               console.log('tablet',counter);
               setCounter(1);
               setNextClick(false);
               setPrevClick(true);
               break;

            case 3:
               // setExpandedPanel("panel1");
               onFrontClick();
               console.log('front',counter);
               setCounter(2);
               setNextClick(false);
               setPrevClick(true);
               break;

            case 4:
               onTopClick();
               console.log('top',counter);
               setCounter(3);
               setNextClick(false);
               setPrevClick(true);
               break;

            case 5:
               onRightClick();
               console.log('right',counter);
               setCounter(4);
               setNextClick(false);
               setPrevClick(true);
               break;

            case 6:
               // setExpandedPanel("panel1");
               onLeftClick();
               console.log('left',counter);
               setCounter(5);
               setNextClick(false);
               setPrevClick(true);
               break;
            case 7:
               // setExpandedPanel("panel3");

               openCloseClick();
               console.log('openClose',counter);
               setCounter(6);
               setNextClick(false);
               setPrevClick(true);
               break;
            case 8:
               // setExpandedPanel("panel3");
               backliteClick();
               console.log('backliteOnOff',counter);
               setCounter(7);
               setNextClick(false);
               setPrevClick(true);
               break;
         }

      }
      prevCounter = counter;
      nextClicked = false;
      prevClicked = true;
   }


   const onNextMob = () => {
      //console.log("****************** Inside next",prevState.counter);
      // setCounter(counter+1);
      if (prevClicked) {
         // alert('iffff');
         // return;
         prevCounter = counter + 2;
      } else {
         // alert('else');
         prevCounter = counter;
      }
      setNextClick(true)
      setPrevClick(false)
      console.log("****************** Inside next prevCounter",prevCounter);
      console.log("****************** Inside next",counter);


      if (window.laptop == 'laptop180') {
         // setlaptop180(true);

         switch (prevCounter) {

            case 0:
               // setExpandedPanel("panel1");
               // setExpandedPanel("panel1");
               onFrontClick();
               console.log('Front',counter);

               setCounter(1);
               setNextClick(true)
               setPrevClick(false)
               break;

            case 1:
               onTopClick();
               console.log('Top',counter);
               setCounter(2);
               setNextClick(true)
               setPrevClick(false)
               break;

            case 2:
               onRightClick();
               console.log('left',counter);
               setCounter(3);
               setNextClick(true)
               setPrevClick(false)
               break;

            case 3:
               // setExpandedPanel("panel3");
               onLeftClick();
               console.log('right',counter);
               setCounter(4);
               setNextClick(true)
               setPrevClick(false)
               break;

            case 4:
               // setExpandedPanel("panel3");

               openCloseClick();

               console.log('openclose',counter);
               setCounter(5);
               setNextClick(true)
               setPrevClick(false)
               break;
            case 5:
               backliteClick();
               console.log('backliteOnOff',counter);
               setCounter(0);
               setNextClick(true)
               setPrevClick(false)
               break;

         }

      } else {
         setlaptop180(false);

         switch (prevCounter) {
            case 0:
               // setExpandedPanel("panel2");
               TentModeClick();
               console.log('tent',counter);
               setCounter(1);
               setNextClick(true)
               setPrevClick(false)
               break;

            case 1:
               TheaterModeClick();
               console.log('theater',counter);
               setCounter(2);
               setNextClick(true)
               setPrevClick(false)
               break;

            case 2:
               TabletModeClick();
               console.log('tablet',counter);
               setCounter(3);
               setNextClick(true)
               setPrevClick(false)
               break;

            case 3:
               // setExpandedPanel("panel1");
               onFrontClick();
               console.log('front',counter);
               setCounter(4);
               setNextClick(true)
               setPrevClick(false)
               break;

            case 4:
               onTopClick();
               console.log('top',counter);
               setCounter(5);
               setNextClick(true)
               setPrevClick(false)
               break;

            case 5:
               onRightClick();
               console.log('right',counter);
               setCounter(6);
               setNextClick(true)
               setPrevClick(false)
               break;

            case 6:
               onLeftClick();
               console.log('left',counter);
               setCounter(7);
               setNextClick(true)
               setPrevClick(false)
               break;
            case 7:
               // setExpandedPanel("panel3");

               openCloseClick();
               console.log('openClose',counter);
               setCounter(8);
               setNextClick(true)
               setPrevClick(false)
               break;
            case 8:
               backliteClick();
               console.log('backliteOnOff',counter);
               setCounter(0);
               setNextClick(true)
               setPrevClick(false)
               break;
         }

      }
      prevCounter = counter;
      nextClicked = true;
      prevClicked = false;
   }

   useEffect(() => {
      getData();
      animationSwitch = window.Animation;
      window.position = 'reset';
      return () => {
         return false
      }
   },[]);


   if (animationSwitch == 'on') { animTime = 1000 }
   else { animTime = 1 }

   const onUpdateZoombar = (e) => {
      // console.log(e.target.value);
      var s = window.scene;
      var deltaScene = 0;
      console.log('onUpdateZoombar',zoombarValue)
      deltaScene = zoombarValue;
      // var delta = (-e.detail * 10.0);
      setPrevDeltaScene(deltaScene);
      // prevDeltaScene = deltaScene;
      if (prevDeltaScene - deltaScene > 0) {
         console.log(deltaScene)
         if (s._nav.NavChangeDolly(deltaScene))
            s.clearRefine();
      } else {
         console.log(-deltaScene)
         if (s._nav.NavChangeDolly(-deltaScene))
            s.clearRefine();
      }
      document.getElementById('sliderRange').value = zoombarValue;
      // console.log(prevDeltaScene)
      // console.log(deltaScene)

   }

   const onZoomIn = (e) => {
      if (window.scene._nav.getZoomFactor() > 0)
         handleZoomChange(null,-1 + (parseFloat(document.getElementById("sliderRange").value)))
   }

   const onZoomOut = (e) => {
      if (window.scene._nav.getZoomFactor() < 100)
         handleZoomChange(null,1 + (parseFloat(document.getElementById("sliderRange").value)))
   }

   let count = 1;
   const onLeft = () => {
      // alert("Rotate product left");
      //window.scene._nav._navYAng += 0.5;
      // console.log(count);
      // window.scene._nav._navYAng = count;
      window.scene._nav.NavRotation([0,0],[2,0]);
      window.scene.clearRefine();


   }
   const onRight = () => {
      // alert("Rotate product right");
      count -= 0.1;
      // console.log(count);
      //window.scene._nav._navYAng -= 0.5;;
      window.scene._nav.NavRotation([0,0],[-2,0]);
      window.scene.clearRefine();
   }
   return (
      <React.Fragment>

         {ReactDOM.createPortal(
            <div id='footerControls'>
               {/* <Hidden only={['sm','md','lg','xl']}>  */}

               <div className="threebtns">
                  <div className="zoombarandRotateContainer">


                     <Hidden only={['xs','lg','xl']}>
                        <div style={topbtns}>
                           <Button className={classes.newBtns + " tabIndexStyle"} id="rLeft" style={topBtnstyle} onClick={onLeft} title="left" variant="outlined" size="small" color="primary">
                              <img alt="diagonalarrowleft" src="./img/diagonalLeftArrow.svg" />
                           </Button>
                           <Button className={classes.newBtns + " tabIndexStyle"} id="rRight" style={topBtnstyle} onClick={onRight} title="right" variant="outlined" size="small" color="primary">
                              <img alt="arrowright" src="./img/diagonalRightArrow.svg" />
                           </Button>
                        </div>

                        <div id="zoomSliderContainer" style={zoombar} >
                           <img style={{ height: '100%',maxWidth: '100%' }} alt="zoombar" src="./img/ZOOMBAR.svg" />

                           <div id="zoomIn" onClick={onZoomIn}></div>
                           <div id="zoomSlider" className="tabIndexStyle" style={{ top: '8px' }}>
                              <div className="rangeslider">
                                 <label>  <input type="range" min="0" max="100" step="1" className="myslider" onChange={handleZoomChange} id="sliderRange" />
                                 </label>
                              </div>
                           </div>
                           <div id="zoomOut" onClick={onZoomOut}></div>
                        </div>
                     </Hidden>
                  </div>

                  <div className="mainDiv" style={clearBoth}>
                     <Hidden only={['xs','lg','xl']}>
                        <Button className="mobthreeButtonsIpad" id="previousView" variant="outlined" color="primary" onClick={props.onPreviousIpad}>
                           <img style={{ height: '20px',width: '24px',paddingRight: '12px' }} alt="arrowleftMob" src="./img/leftArrow.svg" />{window.finalLangues.previous}
                        </Button>
                        <Button className="mobthreeButtonsIpad" variant="outlined" id="resetView" color="primary" onClick={props.onResetIpad}>
                           {window.finalLangues.reset}
                        </Button>
                        <Button className="mobthreeButtonsIpad" variant="outlined" color="primary" id="nextView" onClick={props.onNextIpad}>
                           {window.finalLangues.Next}  <img style={{ height: '20px',width: '24px',paddingLeft: '12px' }} alt="arrowrightMob" src="./img/rightArrow.svg" />
                        </Button>
                     </Hidden>


                     <Hidden only={['sm','md','lg','xl']}>
                        <Button style={mobthreeButtons} variant="outlined" color="primary" onClick={props.onPreviousMob} className={classes.margin}>
                           <img style={{ height: '20px',width: '24px',paddingRight: '12px' }} alt="arrowleftMob" src="./img/leftArrow.svg" />{window.finalLangues.previous}
                        </Button>
                        <Button style={mobthreeButtons} variant="outlined" color="primary" onClick={props.onResetMob} className={classes.margin}>
                           {window.finalLangues.reset}
                        </Button>
                        <Button style={mobthreeButtons} variant="outlined" color="primary" onClick={props.onNextMob} className={classes.margin}>
                           {window.finalLangues.Next}  <img style={{ height: '20px',width: '24px',paddingLeft: '12px' }} alt="arrowrightMob" src="./img/rightArrow.svg" />
                        </Button>
                     </Hidden>
                  </div>
               </div>

            </div>,document.getElementById('footerControMob')
         )}


      </React.Fragment>


   )
}